import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { HeaderColumnComponent } from '../header-column.component';

@Component({
  selector: 'app-header-column-top-flavor',
  templateUrl: './header-column-top-flavor.component.html',
  styleUrls: ['./header-column-top-flavor.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class HeaderColumnTopFlavorComponent extends HeaderColumnComponent {}
